import component from './id-ID/component.json';
import menu from './id-ID/menu.json';
import pages from './id-ID/pages.json';
import settings from './id-ID/settings.json';
import error from './id-ID/error.json';
import role from './id-ID/role.json';

export default {
  'navBar.lang': 'Bahasa',
  'layout.user.link.help': 'Bantuan',
  'layout.user.link.privacy': 'Privasi',
  'layout.user.link.terms': 'Ketentuan',
  'app.copyright.company': 'T-connect Co., Ltd.',
  'app.copyright.produced': 'Diproduksi oleh T-connect',
  'app.preview.down.block': 'Unduh halaman ini ke proyek lokal Anda',
  'app.welcome.link.fetch-blocks': 'Ambil semua block',
  'app.welcome.link.block-list':
    'Bangun halaman standar dengan cepat berdasarkan pengembangan block',
  ...menu,
  ...settings,
  ...component,
  ...pages,
  ...error,
  ...role,
};
